export const RECURRING_INVOICE_EMAIL_TEMPLATE_RECIPIENTS_SEPARATOR = ', '
